import Model from './model';





export default Model.extend( {

    endpoint: 'types/groups?apiVersion=2.0',
    
    defaults: {
        name: '',
        cluster: null,
    },

} );


// WEBPACK FOOTER //
// ./src/js/model/type.group.js